import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosService from '../../../utility/axiosService/axiosService';
import { API_ENDPOINT } from '../../../utility'
import { toast } from "react-toastify"
import { Button, notification, Space } from 'antd';

export const getProductLine = createAsyncThunk(
    'users/getProductLine',
    async (data) => {
        console.log(data);
        var key =  "BH TNDS xe máy"
        var platform = data.platform
        return await axiosService.get(`${API_ENDPOINT}/admin/product-line?limit=${data.limit}&page=${data.page}${platform}`).then((res) => {
            var product =  res.data.data
            // var  fils = data.keyword === "all"? product: product
            
            console.log(res.data.data )
            var filter  =  res.data.data.result.filter((item) => 
            item.name.toLowerCase() !== null && item.name.toLowerCase().includes(data.keyword.toLowerCase()));

            var  fil = data.keyword === null|| data.keyword === "" || data.defaultVal === "all" ? product : filter
            console.log(fil)
   
           
  

            return product


        });
    }
);
const openNotificationWithIcon = type => {
    notification[type]({
      message: 'Thông báo : ',
      description:
        `Xin lỗi , nhưng tính năng này hiện chỉ dành riêng cho tài khoản thind9x, chúng tôi sẽ cập nhật tính năng cho bạn khi
          được sự đồng ý của cấp trên  
        `,
    });
  };
export const getProductLineFilter = createAsyncThunk(
    'users/getProductLine',
    async (data) => {
        console.log(data);
        return await axiosService.get(`${API_ENDPOINT}/admin/product-line`, {
            params: {
                page: data.page,
                limit: data.limit
            }
        }).then((res) => {
          
            var data = res.data.data.result.filter((item) => 
            item.name.toLowerCase() !== null && item.name.toLowerCase().includes(data.toLowerCase())
           
            // ||moment(item.createdAt).utc().format('DD-MM-YYYY') >= dataFilter[0] && moment(item.createdAt).utc().format('DD-MM-YYYY') <=dataFilter[1]
            );
            
            console.log(data)

            return data;                 
        });
    }
);
export const getModalS = createAsyncThunk(
    'users/getProductLine',
    async (data) => {
      console.log(data)
    }
);



const productLineSlice = createSlice({
    name: 'productline',
    initialState: {
        loading: false,
        modal: false,
        data: [],
        productLine:[],
        total_page: 0,
        limit: 0,
        dataOrganizations: [],
        dataDetails: [],
        platformData:"",
        error: null,
        dataFilter: {
            keyword: '',
            page: 1,
            date: []
        },
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        setplatform: (state, { payload }) => {
            state.platformData = payload;
        },
        notiError : () =>{
            openNotificationWithIcon("error")
        },
        removeModal: (state, { payload }) => {
            state.dataDetails = [];
            state.modal = false;
        }
    },
    extraReducers: {
        [getProductLine.pending]: (state) => {
            state.loading = true;
            state.data= []
        },
        [getProductLine.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.limit = payload.limit;
            state.total_page = payload.total_page;
            state.loading = false;
        },
        [getProductLineFilter.fulfilled]: (state, { payload }) => {
            state.data = payload
            state.limit = payload.limit;
            state.total_page = payload.total_page;
            state.loading = false;
        },
      
        [getModalS.fulfilled]: (state, { payload }) => {
            state.data = payload;
            
        },
        [getProductLine.rejected]: (state) => {
            toast.error(`Lấy danh sách không thành công !`);
        },
       
    }
});

export const { getModal, removeModal,notiError,setplatform } = productLineSlice.actions;

export default productLineSlice.reducer;